import React from 'react';
import { Typography } from '@hbf/dsl';

export const Label: React.FC = ({ children, ...props }) => (
  <Typography.H3 color="inherit" noWrap {...props}>
    {children}
  </Typography.H3>
);
